export function fetchGeoLocation() {
	return new Promise<GeolocationPosition>((resolve, reject) => {
		const geo = navigator?.geolocation;
		if (!geo) reject("Navigator nicht gefunden");
		geo.getCurrentPosition(
			(position) => resolve(position),
			({code}: GeolocationPositionError) => {
				switch (code) {
					case GeolocationPositionError.PERMISSION_DENIED:
						reject("Geolocation-Abfrage abgelehnt. überprüfen Sie die Browsereinstellungen")
						break;
					case GeolocationPositionError.POSITION_UNAVAILABLE:
						reject("Geolocation-Daten nicht vorhanden. überprüfen Sie die Browsereinstellungen")
						break;
					case GeolocationPositionError.TIMEOUT:
						reject("Zeit für Geolocation-Abfrage abgelaufen.")
						break;
					default:
						reject("Unbekannter Fehler. überprüfen Sie die Browsereinstellungen")
				}
			},  {timeout: 30000}
		)
	})
}